module.exports = __webpack_public_path__ + "static/img/banner_01.6c53dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/es/banner_01.png
// module id = DzLW
// module chunks = 0